import { stats } from '@fiverr-private/obs';
import { APP_NAME } from '../../../configuration/constants';

/**
 * The current service prefixed stats instance.
 */
export const metric = stats.prefix(`services.${APP_NAME}`);
